export function getImgUrl(imgName: string) {
    const baseUrl = "https://mealhaus.imgix.net/";
    return `${baseUrl}${imgName}`;
  }
  